/*
 * Loby cart drawer — "You may also like" pager.
 *
 * Dawn re-renders #CartDrawer via innerHTML on every cart change, which does
 * NOT run inline <script> tags. So this is loaded once from theme.liquid and
 * uses event delegation + a MutationObserver so it keeps working across
 * re-renders.
 */
(function () {
  function stripFor(button) {
    const wrap = button.closest('[data-loby-recs]');
    return wrap ? wrap.querySelector('[data-loby-recs-strip]') : null;
  }

  function syncArrows(strip) {
    const wrap = strip.closest('[data-loby-recs]');
    if (!wrap) return;
    const max = strip.scrollWidth - strip.clientWidth - 1;
    const prev = wrap.querySelector('.loby-cart-recs-arrow[data-dir="-1"]');
    const next = wrap.querySelector('.loby-cart-recs-arrow[data-dir="1"]');
    if (prev) prev.disabled = strip.scrollLeft <= 0;
    if (next) next.disabled = strip.scrollLeft >= max;
  }

  function pageScroll(strip, delta) {
    const start = strip.scrollLeft;
    const target = Math.max(0, Math.min(start + delta, strip.scrollWidth - strip.clientWidth));
    if (Math.abs(target - start) < 1) return;
    // Prefer a native smooth scroll; fall back to instant if the browser
    // doesn't animate it (e.g. reduced-motion, or it stalls).
    try {
      strip.scrollTo({ left: target, behavior: 'smooth' });
    } catch (e) {
      strip.scrollLeft = target;
    }
    setTimeout(() => {
      if (Math.abs(strip.scrollLeft - target) > 2) strip.scrollLeft = target;
      syncArrows(strip);
    }, 400);
  }

  // Add a recommended product straight from the drawer, then re-render it.
  async function addRecommendation(button) {
    const id = button.dataset.variantId;
    if (!id || button.dataset.busy) return;
    const drawer = document.querySelector('cart-drawer');
    button.dataset.busy = '1';
    button.classList.add('is-busy');
    const label = button.textContent;
    button.textContent = 'Adding…';
    try {
      const sections = drawer.getSectionsToRender().map((s) => s.id).join(',');
      const res = await fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ id: Number(id), quantity: 1, sections, sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (data.status) {
        button.textContent = data.description || 'Unavailable';
        button.dataset.busy = '';
        button.classList.remove('is-busy');
        return;
      }
      drawer.renderContents(data); // re-renders #CartDrawer (drawer is already open)
    } catch (e) {
      button.textContent = label;
      button.dataset.busy = '';
      button.classList.remove('is-busy');
    }
  }

  // "Log in" in the empty drawer → open the header's <shopify-account> pop-up
  // instead of a full-page redirect to the hosted auth flow.
  function openAccount() {
    const acct = document.querySelector('shopify-account');
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.close();
    if (acct) {
      const trigger = (acct.shadowRoot && acct.shadowRoot.querySelector('a, button')) || acct;
      trigger.click();
    } else {
      window.location.href = '/account';
    }
  }

  // Delegated click — survives drawer re-renders.
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-loby-open-account]')) {
      event.preventDefault();
      openAccount();
      return;
    }
    const addBtn = event.target.closest('[data-loby-rec-add]');
    if (addBtn) {
      event.preventDefault();
      addRecommendation(addBtn);
      return;
    }
    const btn = event.target.closest('.loby-cart-recs-arrow');
    if (!btn) return;
    const strip = stripFor(btn);
    if (!strip) return;
    const first = strip.querySelector('.loby-cart-rec');
    const stepWidth = (first ? first.offsetWidth + 16 : 240) * Number(btn.dataset.dir);
    pageScroll(strip, stepWidth);
  });

  // Keep arrow disabled-state in sync: attach a scroll listener to each strip as
  // it appears, and re-sync whenever #CartDrawer is re-rendered.
  const seen = new WeakSet();
  function wireStrips() {
    document.querySelectorAll('[data-loby-recs-strip]').forEach((strip) => {
      if (!seen.has(strip)) {
        seen.add(strip);
        strip.addEventListener('scroll', () => syncArrows(strip), { passive: true });
      }
      syncArrows(strip);
    });
  }

  const drawer = document.querySelector('#CartDrawer');
  if (drawer) {
    new MutationObserver(wireStrips).observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireStrips);
  } else {
    wireStrips();
  }
})();
